import React from "react";
import styled from "styled-components";
import Toggle from "../../../../core/components/CollapsToggle/Toggle";
import Level2Table from "./Level2Table";
import LevelGenerator2 from "./LevelGenerator2";
import DeletePropertyLevel2 from "../../../Dialog/contentUnit/ProductProperty/DeletePropertyLevel2";
import EditPropertyLevel2 from "../../../Dialog/contentUnit/ProductProperty/EditPropertyLevel2";
import { useRecoilState } from "recoil";
import { ContentUnitModal } from "../../../../shared/content-unit";
import BreadCrumb from "../../../BreadCrumb/BreadCrumb";

function LevelSecond() {
  const [modualsContent, setModuals] = useRecoilState(ContentUnitModal);

  return (
    <>
      <BreadCrumb
        margin="mt-3"
        num1="واحد محتوا"
        num2="ویژگی های محصول"
        num3="سطح دوم"
        href1="/dashboard/content-controller"
        href2="/dashboard/content-controller/productProperty"
      />
      <LevelSecondStyle>
        {modualsContent.deletePropertyLevel2.isShow && (
          <DeletePropertyLevel2
            show={modualsContent.deletePropertyLevel2.isShow}
            handleClose={() =>
              setModuals({
                ...modualsContent,
                deletePropertyLevel2: {
                  ...modualsContent.deletePropertyLevel2,
                  isShow: false,
                },
              })
            }
          />
        )}
        {modualsContent.updatePropertyLevel2.isShow && (
          <EditPropertyLevel2
            show={modualsContent.updatePropertyLevel2.isShow}
            handleClose={() =>
              setModuals({
                ...modualsContent,
                updatePropertyLevel2: {
                  ...modualsContent.updatePropertyLevel2,
                  isShow: false,
                },
              })
            }
          />
        )}
        {/* <LevelSecondStyle> */}
        <Toggle title={"افزودن  ویژگی به سطح دوم"}>
          <LevelGenerator2 />
        </Toggle>
        <Level2Table />
      </LevelSecondStyle>
    </>
  );
}

const LevelSecondStyle = styled.div``;

export default LevelSecond;
